import w from "./index.es518.js";
function g(n, d) {
  var c = d.schema, a = [];
  if (c)
    return {
      data: n,
      mergedCells: a
    };
  for (var s = function() {
    n = n.slice();
    for (var f = 0; f < n.length; )
      n[f] = n[f].slice(), f++;
    return s = function() {
      return n;
    }, n;
  }, t = 0; t < n.length; ) {
    for (var i = n[t], o = 0; o < i.length; ) {
      var r = i[o];
      if (r) {
        var e = r.span, l = e === void 0 ? 1 : e, p = r.rowSpan, u = p === void 0 ? 1 : p;
        (l > 1 || u > 1) && (v({
          data: n,
          rowIndex: t,
          columnIndex: o,
          span: l,
          rowSpan: u,
          cloneData: s
        }), a.push([[t, o], [t + (u ? u - 1 : 0), o + (l ? l - 1 : 0)]]));
      }
      o++;
    }
    t++;
  }
  return {
    data: n,
    mergedCells: a
  };
}
function v(n) {
  var d = n.data, c = n.rowIndex, a = n.columnIndex, s = n.span, t = n.rowSpan, i = n.cloneData, o = w(d[c][a]);
  o && (d = i());
  for (var r = c; r <= c + (t - 1); ) {
    for (var e = a; e <= a + (s - 1); ) {
      var l = d[r][e];
      if (r > c || e > a) {
        if (l != null)
          throw new Error("[write-excel-file] When using `span` or `rowSpan` parameters, all hidden overlapped cells should be represented by `null`s or `undefined`s. Cell at row ".concat(c + 1, " and column ").concat(a + 1, " is configured with `span` ").concat(s, " and `rowSpan` ").concat(t, ". Cell at row ").concat(r + 1, " and column ").concat(e + 1, " is neither `null` nor `undefined`: ").concat(JSON.stringify(l)));
        o && (d[r][e] = o);
      }
      e++;
    }
    r++;
  }
}
export {
  g as default
};
//# sourceMappingURL=index.es502.js.map
